import { CSSProperties, ReactNode, forwardRef } from "react"
import NextLink from "next/link"
import { observer } from "mobx-react"
import { useStore } from "@features/common"
import { config } from "@lib/config"

interface RouterLinkProps extends RootProps {
  uri: string
  routing?: boolean
  availableInChinese?: boolean
  availableInSpanish?: boolean
}

interface RootProps {
  className?: string
  style?: CSSProperties
  onClick?: () => void
  children: ReactNode
  target?: string
  lang?: string
}

export const RouterLink = observer(function RouterLink(props: RouterLinkProps) {
  const {
    className,
    style,
    uri,
    routing = true,
    onClick,
    children,
    target,
    availableInChinese,
    availableInSpanish,
    ...otherProps
  } = props
  const { GlobalModel } = useStore()

  const handleClick = () => {
    if (onClick) onClick()
  }

  // eslint-disable-next-line
  const langUriPrefix = GlobalModel?.lang
    ? `/${
        (GlobalModel.lang === "zh" && !availableInChinese) ||
        (GlobalModel.lang === "es" && !availableInSpanish)
          ? "en"
          : GlobalModel.lang
      }`
    : ""
  const resolveHref = routing ? `${langUriPrefix}${uri}` : uri
  const href = `${routing ? config.data.prefix : ""}${resolveHref}`

  return (
    <NextLink href={resolveHref}>
      <LinkRoot
        href={href}
        onClick={handleClick}
        className={className}
        style={style}
        target={target}
        {...otherProps}
      >
        {children}
      </LinkRoot>
    </NextLink>
  )
})

const LinkRoot = forwardRef((props: RootProps & { href?: string }, ref) => {
  const resolve: RootProps = { ...props }
  // @ts-ignore
  delete resolve.uri
  // @ts-ignore
  resolve.ref = ref

  return <a {...resolve}>{props.children}</a>
})
